import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import ComandosTab from './ComandosTab';
import CargaArchivos from './CargaArchivos';
import DescargaArchivos from './DescargaArchivos';
import RolesYPermisosTab from './RolesYPermisosTab';

export const Configuracion = () => {
  const [activeTabKey, setActiveTabKey] = useState('comandos');

  const items = [
    { key: 'comandos', label: 'Comandos', children: <ComandosTab /> },
    { key: 'carga', label: 'Carga de archivos', children: <CargaArchivos /> },
    { key: 'descarga', label: 'Descarga archivo', children: <DescargaArchivos /> },
    { key: 'roles-permisos', label: <span data-testid="tab-roles-permisos">Roles y Permisos</span>, children: <RolesYPermisosTab /> },
  ];

  return (
    <Card style={{ width: '100%' }}>
      <Tabs
        items={items}
        activeKey={activeTabKey}
        onChange={setActiveTabKey}
        tabProps={{ size: 'small' }}
      />
    </Card>
  );
};

export default Configuracion;
